import { render, staticRenderFns } from "./ModalAddGudang.vue?vue&type=template&id=67b89efa&scoped=true"
import script from "./ModalAddGudang.vue?vue&type=script&lang=js"
export * from "./ModalAddGudang.vue?vue&type=script&lang=js"
import style0 from "./ModalAddGudang.vue?vue&type=style&index=0&id=67b89efa&prod&lang=scss&scoped=true"
import style1 from "./ModalAddGudang.vue?vue&type=style&index=1&id=67b89efa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b89efa",
  null
  
)

export default component.exports